'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@eliadmin/core/src/components/ui/select';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import { changeLanguage } from '@eliadmin/core/src/server/api-client';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { redirect, usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export function getFlagEmoji(countryCode: string) {
  if (countryCode === 'en') {
    countryCode = 'gb';
  } else if (countryCode === 'cs') {
    countryCode = 'cz';
  }

  return String.fromCodePoint(
    ...[...countryCode.toUpperCase()].map(char => 0x1f1e6 - 65 + char.charCodeAt(0)),
  );
}

export function LanguageSelect() {
  const [isLoading, setIsLoading] = useState(false);
  const locale = useLocaleStore(s => s.currentLocale);
  const locales = useLocaleStore(s => s.supportedLocales);
  const [selectedLocale, setSelectedLocale] = useState(
    locales.find(localeIterator => localeIterator.locale === locale),
  );
  const pathname = usePathname();

  const handleLocaleChange = async (newLocale: string) => {
    if (newLocale === 'sk') {
      if (locale !== 'cs') {
        if (window.location.href.includes('https://eshop.smako.cz')) {
          await changeLanguage({ locale: 'cs' });
        } else {
          await changeLanguage({ locale: newLocale });
        }
      }
      window.location.href = 'https://eshop.smako.sk';
      return;
    }
    if (newLocale === 'cs') {
      if (locale !== 'sk') {
        if (window.location.href.includes('https://eshop.smako.sk')) {
          await changeLanguage({ locale: 'sk' });
        } else {
          await changeLanguage({ locale: newLocale });
        }
      }
      window.location.href = 'https://eshop.smako.cz';
      return;
    }

    let newRoute = `/${newLocale}${pathname}`;
    if (pathname.startsWith(`/${locale}`)) {
      newRoute = pathname.replace(`/${locale}`, `/${newLocale}`);
    }
    setIsLoading(true);
    await changeLanguage({ locale: newLocale });
    window.location.replace(newRoute);
  };

  useEffect(() => {
    setSelectedLocale(locales.find(localeIterator => localeIterator.locale === locale));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return (
    <div className={cn('w-auto', 'ea-language-select')}>
      <Select value={locale} onValueChange={handleLocaleChange}>
        <SelectTrigger
          aria-label={`${locale.startsWith('en') ? 'Language' : 'Jazyk'}: ${selectedLocale?.name || locale}`}
          className={cn('border-none text-white outline-none', 'ea-language-select__trigger')}
          innerTriggerClassName="focus:ring-transparent"
          disabled={isLoading}
        >
          {isLoading ? (
            <Spinner className={cn('w-8', 'ea-language-select__spinner')} />
          ) : selectedLocale?.image?.url ? (
            <Image
              src={selectedLocale.image.url}
              alt={resolveImageAlt(selectedLocale?.image, selectedLocale?.locale || '')}
              className={cn('min-h-5', 'ea-language-select__flag-image')}
              width={40}
              height={32}
            />
          ) : (
            <span className={cn('px-2 text-xl', 'ea-language-select__flag')}>
              {getFlagEmoji(locale)}
            </span>
          )}
        </SelectTrigger>
        <SelectContent className={cn('', 'ea-language-select__content')}>
          {locales.map(locale => (
            <SelectItem
              key={`${locale.name}-${locale.locale}`}
              value={locale.locale}
              className={cn('', 'ea-language-select__item')}
            >
              {locale.image?.url ? (
                <span className={cn('', 'ea-language-select__flag')}>
                  <Image
                    src={locale.image.url}
                    alt={resolveImageAlt(locale?.image, locale?.locale)}
                    height={0}
                    width={0}
                    className={cn('', 'ea-language-select__flag-image')}
                  />
                </span>
              ) : (
                <>
                  <span className={cn('pr-2', 'ea-language-select__flag')}>
                    {getFlagEmoji(locale.locale)}
                  </span>
                  {locale.name}
                </>
              )}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

// <div className={cn('w-auto', 'ea-language-select')}>
//   <Select value={locale} onValueChange={handleLocaleChange}>
//     <SelectTrigger
//       className={cn('border-none text-white outline-none', 'ea-language-select__trigger')}
//       innerTriggerClassName="focus:ring-transparent"
//       disabled={isLoading}
//     >
//       {isLoading ? (
//         <Spinner className={cn('', 'ea-language-select__spinner')} />
//       ) : (
// <span className={cn('px-2', 'ea-language-select__flag')}>
//   <Image
//     src={locales.find(l => l.locale === locale)?.image?.url}
//     alt={locales.find(l => l.locale === locale)?.name}
//     height={0}
//     width={0}
//     className={cn('', 'ea-language-select__flag-image')}
//   />
// </span>
//       )}
//     </SelectTrigger>
//     <SelectContent className={cn('text-white', 'ea-language-select__content')}>
//       {locales.map(locale => (
//         <SelectItem
//           key={`${locale.name}-${locale.locale}`}
//           value={locale.locale}
//           className={cn('', 'ea-language-select__item')}
//         >
//           <Image
//             src={locale.image?.url}
//             alt={locale?.name}
//             height={0}
//             width={0}
//             className={cn('', 'ea-language-select__flag-image')}
//           />
//         </SelectItem>
//       ))}
//     </SelectContent>
//   </Select>
// </div>
